import { Box } from "@mui/material";

import { useAuthentication } from "../../hooks";
import { ReactComponent as PacknetLogo } from "../../assets/application-logos/packnet-logo.svg";
import { ReactComponent as PacknetLogoLight } from "../../assets/packnet-platform-light.svg";
import { ReactComponent as SupportLogo } from "../../assets/application-logos/support-logo.svg";
import { ReactComponent as TenantManagementLogo } from "../../assets/application-logos/tenant-management-logo.svg";
import { ReactComponent as CompanyManagementLogo } from "../../assets/application-logos/company-management-logo.svg";

export interface ApplicationLogoProps {
	readonly variant?: "default" | "light";
}

export const ApplicationLogo = ({ variant = "default" }: ApplicationLogoProps) => {
	const { applicationName, applicationEnvironment } = useAuthentication();

	const getLogo = () => {
		if (applicationName === "TenantManagement") {
			return TenantManagementLogo;
		}

		if (applicationName === "Support") {
			return SupportLogo;
		}

		if (applicationName === "Company") {
			return CompanyManagementLogo;
		}

		return variant === "light" ? PacknetLogoLight : PacknetLogo;
	};

	return (
		<Box component={getLogo()} sx={{ filter: applicationEnvironment === "preprod" ? "grayscale(1)" : undefined }} />
	);
};
